export default __webpack_public_path__ + "static/media/tab2_img1.275aca34.png";